import { linkedGiftUpdates } from './seedelia-cart-offers-v2.js';
import { CartLinesUpdateEvent } from '@shopify/events';

function updateOfferPrices() {
  for (const option of document.querySelectorAll('[data-offer-option][data-native-price]')) {
    const currency = option.dataset.currency;
    const rate = currency === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);
    if (!currency || !Number.isFinite(rate) || rate <= 0) continue;
    const total = Number(option.dataset.nativePrice) * Number(option.dataset.paidQuantity)
      - Math.round(Number(option.dataset.discountUsd) * rate);
    const price = option.querySelector('.seedelia-offer-option__price > strong');
    const unit = option.querySelector('.seedelia-offer-option__unit');
    const format = new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'currency', currency, currencyDisplay: 'narrowSymbol',
    });
    if (price) price.textContent = `${format.format(total / 100)} ${currency}`;
    if (unit) {
      unit.dataset.suffix ||= unit.textContent.replace(/^.*?\d[\d.,]*\s*/, '');
      unit.textContent = `${format.format(Math.round(total / Number(option.dataset.bottleCount)) / 100)} ${unit.dataset.suffix}`;
    }
  }
}

updateOfferPrices();
document.addEventListener('shopify:section:load', updateOfferPrices);

document.addEventListener('submit', async (event) => {
  const form = event.target.closest?.('.verolia-product-form');
  const offer = form?.closest('[data-seedelia-cart-offer]');
  if (!offer) return;
  event.preventDefault();
  const button = form.querySelector('.seedelia-offer__cta');
  if (!button || button.disabled) return;
  const option = offer.querySelector('[data-offer-radio]:checked')?.closest('[data-offer-option]');
  const message = offer.querySelector('[data-cart-message]');
  const total = Number(option?.dataset.bottleCount || 1);
  const root = offer.dataset.cartRoot || '/';
  const variant = offer.dataset.variant;
  const paidQuantity = total >= 4 ? 2 : 1;
  const withBonus = total >= 2;
  if (!option || !variant || (withBonus && !offer.dataset.bonusVariant)) {
    message.textContent = 'This offer is currently unavailable. Please try another offer.';
    message.hidden = false;
    return;
  }
  const items = [{ id: Number(variant), quantity: paidQuantity, properties: { _seedelia_bonus: withBonus ? 'included' : 'none' } }];
  if (withBonus) items.push({ id: Number(offer.dataset.bonusVariant), quantity: paidQuantity, properties: { _seedelia_first_order_bonus: 'true' } });
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');
  message.hidden = true;
  const label = button.innerHTML;
  button.textContent = 'Adding…';
  const deferred = CartLinesUpdateEvent.createPromise();
  deferred.promise.catch(() => {});
  offer.dispatchEvent(new CartLinesUpdateEvent({
    action: 'add', context: 'product',
    lines: items.map(item => ({ merchandiseId: String(item.id), quantity: item.quantity })),
    promise: deferred.promise,
  }));
  let added = false;
  try {
    const sections = [...new Set([...document.querySelectorAll('cart-items-component')].map(el => el.dataset.sectionId).filter(Boolean))].slice(0, 5);
    const response = await fetch(`${root}cart/add.js`, {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items, sections, sections_url: window.location.pathname }),
    });
    const data = await response.json();
    if (!response.ok || data.status) throw new Error(data.description || data.message || 'Unable to add this offer. Please try again.');
    added = true;
    const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
    if (!cartResponse.ok) throw new Error('Your items were added. Open the cart to view them.');
    let cart = await cartResponse.json();
    let renderedSections = data.sections;
    const updates = linkedGiftUpdates(cart);
    if (Object.keys(updates).length) {
      const syncResponse = await fetch(`${root}cart/update.js`, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ updates, sections, sections_url: window.location.pathname }),
      });
      const syncedCart = await syncResponse.json();
      if (!syncResponse.ok || syncedCart.errors) throw new Error('Please refresh your cart before continuing.');
      cart = syncedCart;
      renderedSections = syncedCart.sections;
    }
    deferred.resolve({
      cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart),
      detail: { items: cart.items, itemCount: cart.item_count, sections: renderedSections, source: 'seedelia-offer', didError: false },
    });
    await customElements.whenDefined('theme-drawer');
    const drawer = document.getElementById('cart-drawer');
    if (drawer?.open) drawer.open();
    else window.location.assign(`${root}cart`);
  } catch (error) {
    deferred.reject(error);
    message.textContent = added ? 'Your items were added. Open the cart to view them before adding again.' : error.message;
    message.hidden = false;
  } finally {
    button.innerHTML = label;
    button.disabled = false;
    button.removeAttribute('aria-busy');
  }
});


